import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '@app/_services';
import { ChatbotService } from '@app/_services/chatbot.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private chatbotService: ChatbotService
  ) { }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const sessionCheckBackend = this.authenticationService.sessionCheckBackend();
    sessionCheckBackend.pipe().subscribe(data => {
      if (data.code !== 200) {
        this.authenticationService.clearAllData();
      }
    });

    return true;
  }

}
